module.exports = __webpack_public_path__ + "media/ctq-video-showcase_ff.34df5e0e.mp4";